import { render, staticRenderFns } from "./SidebarList.vue?vue&type=template&id=038f0225&"
import script from "./SidebarList.vue?vue&type=script&lang=js&"
export * from "./SidebarList.vue?vue&type=script&lang=js&"
import style0 from "./SidebarList.vue?vue&type=style&index=0&id=038f0225&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports